export default __webpack_public_path__ + "static/media/profile_mock_banner.0b9d9816.jpg";